import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	fill: "none",
	viewBox: "0 0 14 14",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M6.99967 13.6663C3.31767 13.6663 0.333008 10.6817 0.333008 6.99967C0.333008 3.31767 3.31767 0.333008 6.99967 0.333008C10.6817 0.333008 13.6663 3.31767 13.6663 6.99967C13.6663 10.6817 10.6817 13.6663 6.99967 13.6663ZM6.33301 8.99967V10.333H7.66634V8.99967H6.33301ZM6.33301 3.66634V7.66634H7.66634V3.66634H6.33301Z"
	})
});
const ForwardRef = forwardRef(SvgExclamationCircle);
export default ForwardRef;
